import { Link } from "react-router-dom";
import {
  Facebook,
  Twitter,
  Instagram,
  Mail,
  Phone,
  MapPin,
  Youtube,
  Linkedin,
} from "lucide-react";

const footerSections = [
  {
    title: "Shop",
    links: [
      { name: "All Products", href: "/products" },
      { name: "Electronics", href: "/products?category=Electronics" },
      { name: "Fashion", href: "/products?category=Fashion" },
      { name: "Home & Office", href: "/products?category=Home%20&%20Office" },
      { name: "Sports & Fitness", href: "/products?category=Sports%20&%20Fitness" },
    ],
  },
  {
    title: "Customer Service",
    links: [
      { name: "Contact Us", href: "/contact" },
      { name: "Shipping Info", href: "/shipping" },
      { name: "Returns", href: "/returns" },
      { name: "Size Guide", href: "/size-guide" },
      { name: "FAQ", href: "/faq" },
    ],
  },
  {
    title: "Company",
    links: [
      { name: "About Us", href: "/about" },
      { name: "Careers", href: "/careers" },
      { name: "Press", href: "/press" },
      { name: "Sustainability", href: "/sustainability" },
      { name: "Privacy Policy", href: "/privacy" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="max-w-7xl mx-auto px-4 py-4 bg-white border-t">
      <div className="container mx-auto px-4">     
        {/* Main Footer Content */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand section */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img src="../assets/logo.webp" alt="Logo" className="h-14 w-14" />
            </Link>
            <p className="text-gray-500 mb-6 max-w-md">
              Discover premium products that blend style, innovation, and quality. Your destination for modern lifestyle essentials.
            </p>
            <div className="space-y-2 text-sm text-gray-500">
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4" />
                <span>P.O. Box. SP62144 28 West Bay Street, Nassau, Bahamas</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span>242-457-4254</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <span><a href="mailto:sales@sapodil.com">sales@sapodil.com</a></span>
              </div>
            </div>
          </div>

          {/* Footer Sections */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="font-semibold mb-4 text-gray-800">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-gray-500 hover:text-blue-600 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="py-6 border-t flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500 mb-4 md:mb-0">
            © 2025 Sapodil Bahamas Solutions Ltd. All rights reserved.
          </p>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-500">Follow us:</span>
            <div className="flex space-x-2">
              <Link to="https://www.youtube.com/@sapodilsolutions" target="_blank" className="text-gray-500 hover:text-blue-600 transition">
              <Youtube  className="h-5 w-5" />
              </Link>
              <Link to="https://www.instagram.com/sapodilsolutions" target="_blank" className="text-gray-500 hover:text-pink-500 transition">
                <Instagram className="h-5 w-5" />
              </Link>
              <Link to="https://www.facebook.com/sapodilsolutions" target="_blank" className="text-gray-500 hover:text-blue-600 transition">
                <Facebook className="h-5 w-5" />
              </Link>
              <Link to="#" className="text-gray-500 hover:text-blue-600 transition">
                <Twitter className="h-5 w-5" />
              </Link>
              <Link to="https://www.linkedin.com/company/sapodil-bahamas-solutions/" target="_blank" className="text-gray-500 hover:text-blue-600 transition">
              <Linkedin  className="h-5 w-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;